import React, { useContext } from 'react';
import { View } from 'react-native';
import { Button } from '@rneui/themed';
import PropTypes from 'prop-types';
import { H3 } from '../../text';
import { StyledWebView } from '../../common/StyledWebView';
import LayoutContext from '../../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'cornerblockCta';

export const CornerblockCta = ({
    backgroundColor,
    cta1Title,
    cta1ButtonText,
    cta1Description,
    cta1Link,
    cta2ButtonText,
    cta2Link,
    cta3ButtonText,
    cta3Link,
    followContentLink = () => {},
    nodeTypeAlias = 'CornerblockCta',
    textColor
}) => {
    const { layout } = useContext(LayoutContext);

    const renderCta = (buttonText, isExternal, internalKey, externalUrl) => {
        if (!buttonText) {
            return null;
        }

        return (
            <Button
                containerStyle={{ flexDirection: 'row', marginTop: cta1Description.isEmpty() ? layout.styleGuide.spacer3 : undefined }}
                buttonStyle={{ borderColor: textColor, maxWidth: 200, marginVertical: 5 }}
                onPress={async () => await followContentLink(isExternal, internalKey, externalUrl)}
                title={buttonText}
                titleStyle={{ color: textColor, fontFamily: 'GothamBook', fontSize: layout.device.os.equals('web') ? '18pt' : 18 }}
                type='outline'
            />
        );
    };

    return (
        <View
            style={{
                backgroundColor: backgroundColor,
                flex: 1,
                marginBottom: layout.styleGuide.componentSeparator,
                paddingVertical: layout.styleGuide.spacer2,
                paddingHorizontal: Math.floor(layout.styleGuide.indent * 3)
            }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`,
                spacerLeft: `StyleGuide.Indent*3(${Math.floor(layout.styleGuide.indent * 3)})`,
                spacerRight: `StyleGuide.Indent*3(${Math.floor(layout.styleGuide.indent * 3)})`,
                spacerTop: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})`
            }}
        >
            <View style={{ marginHorizontal: layout.styleGuide.horizontalMargin, marginVertical: layout.styleGuide.verticalMargin }}>
                {!!cta1Title && (
                    <View
                        style={{ alignItems: 'center', marginVertical: layout.styleGuide.spacer4 }}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})`, spacerTop: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                    >
                        <H3 style={{ color: textColor }} text={cta1Title} />
                    </View>
                )}
                {!!cta1Description && cta2ButtonText.length === 0 && cta3ButtonText.length === 0 && (
                    <View>
                        <StyledWebView html={cta1Description} nodeId={STYLED_WEB_VIEW_ID} textProps={{ style: { color: textColor || '#fff' } }} />
                    </View>
                )}
            </View>
            <View style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                {renderCta(cta1ButtonText, cta1Link.isExternal, cta1Link.internalKey, cta1Link.externalUrl)}
                {renderCta(cta2ButtonText, cta2Link.isExternal, cta2Link.internalKey, cta2Link.externalUrl)}
                {renderCta(cta3ButtonText, cta3Link.isExternal, cta3Link.internalKey, cta3Link.externalUrl)}
            </View>
        </View>
    );
};

CornerblockCta.propTypes = {
    backgroundColor: PropTypes.string,
    cta1ButtonText: PropTypes.string,
    cta1Description: PropTypes.string,
    cta1Link: PropTypes.shape({
        externalURL: PropTypes.string,
        internalURL: PropTypes.string
    }),
    cta2ButtonText: PropTypes.string,
    cta2Link: PropTypes.shape({
        externalURL: PropTypes.string,
        internalURL: PropTypes.string
    }),
    cta3ButtonText: PropTypes.string,
    cta3Link: PropTypes.shape({
        externalURL: PropTypes.string,
        internalURL: PropTypes.string
    }),
    followContentLink: PropTypes.func,
    title: PropTypes.string,
    textColor: PropTypes.string
};
